
import { defineComponent, ref, shallowRef, computed, watch } from "vue";
import { EventManagementAPI } from "@/services/api/EventManagement.service";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { EVENTMANAGEMENT_TABS } from "./dataTableOptions";
import VZTabs from "@/components/content/VZTabs.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "event-detail",
  components: { VZTabs },
  setup(_, { emit }) {
    const loading = ref(false);
    const route = useRoute();
    const tabs = shallowRef<ITabConfig[]>(EVENTMANAGEMENT_TABS());
    const tableRowClick = (item) => {
      tabs.value = tabs.value.map((tab) => {
        return { ...tab, props: { ...tab.props, data: item } };
      });
    };
    const eventWebId = computed(() => {
      return (route.params.id as string) || ("0" as string);
    });
    const queryUpdate = async (webId: string) => {
      try {
        loading.value = true;
        const data = await EventManagementAPI.getInstance().getEvent(+webId);
        tableRowClick(data);
        emit("updateRoute", {
          title: data.eventName,
          icon: "bi bi-box fs-2 text-primary",
        });
      } finally {
        loading.value = false;
      }
    };

    watch(
      eventWebId,
      async (val) => {
        if (val && val !== "0") {
          queryUpdate(val);
        }
      },
      { immediate: true }
    );
    return {
      tabs,
      loading,
      tableRowClick,
    };
  },
});
